import {shallowEqual, useDispatch, useSelector} from "react-redux";
import Summary from "../summary/templates/Summary";
import History from "../designHistory/component/page/History";
import React, {useEffect} from "react";
import MediaWallSummary from "../mediaWall/organisms/MediaWallSummary";
import {summaryAction} from "../../redux/store";

const OverlayPanel = ({summaryData=null}) => {
  const { isOverlayPanelActive, overlayPanelItem, runningSummaryAnimation, connectMode } = useSelector(state => ({
    isOverlayPanelActive: state.overlayPanel.isOverlayPanelActive,
    overlayPanelItem: state.overlayPanel.overlayPanelItem,
    runningSummaryAnimation: state.summary.runningSummaryAnimation,
    connectMode: state.theme.connectMode
  }), shallowEqual);

  const dispatch = useDispatch();

  const innerComponent = {
    SUMMARY: connectMode === "mediaWall" ? <MediaWallSummary summaryData={summaryData}/> : <Summary/>,
    MY_DESIGN_HISTORY: <History/>,
  }

  useEffect(() => {
    dispatch(summaryAction.clearScreenShot());
  }, [overlayPanelItem]);


  return (
    <div className={`overlay-panel ${isOverlayPanelActive ? "active" : ""}`} style={runningSummaryAnimation ? {visibility: "hidden"} : {}}>
      {
        isOverlayPanelActive ? innerComponent[overlayPanelItem] : null
      }
    </div>
  )
}

export default OverlayPanel;
